// extracted by mini-css-extract-plugin
module.exports = {"sticky_footer_ad":"style_sticky_footer_ad__G_3F0","initial_sticky_ad_hidden":"style_initial_sticky_ad_hidden__2cxYp"};